import React from "react";

const NoDocs = ({ width = 100, height = 100, ...props }: any) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M62.5006 94.2904H37.5006C26.2455 94.2904 18.3327 91.884 13.224 86.7754C8.11533 81.6667 5.70898 73.7538 5.70898 62.4987V37.4987C5.70898 26.2436 8.11533 18.3307 13.224 13.222C18.3327 8.11338 26.2455 5.70703 37.5006 5.70703H58.334C59.7662 5.70703 60.959 6.89984 60.959 8.33203C60.959 9.76422 59.7662 10.957 58.334 10.957H37.5006C27.8612 10.957 21.1779 12.6664 16.9231 16.9212C12.6684 21.1759 10.959 27.8593 10.959 37.4987V62.4987C10.959 72.1381 12.6684 78.8215 16.9231 83.0762C21.1779 87.331 27.8612 89.0404 37.5006 89.0404H62.5006C72.1401 89.0404 78.8234 87.331 83.0782 83.0762C87.3329 78.8215 89.0423 72.1381 89.0423 62.4987V41.6654C89.0423 40.2332 90.2351 39.0404 91.6673 39.0404C93.0995 39.0404 94.2923 40.2332 94.2923 41.6654V62.4987C94.2923 73.7538 91.886 81.6667 86.7773 86.7754C81.6686 91.884 73.7558 94.2904 62.5006 94.2904Z"
        fill="var(--color-stroke-active)"
        stroke="var(--color-stroke-active)"
      />
      <path
        d="M57.3085 5.92407L57.3156 5.92128L57.3226 5.91827C58.2888 5.50419 59.4094 5.73802 60.193 6.48318L93.5221 39.8122C94.2566 40.5468 94.5 41.7049 94.0828 42.6784C93.6599 43.6649 92.7133 44.292 91.6673 44.292H75.0007C67.9216 44.292 63.1402 42.912 60.1146 39.8864C57.089 36.8608 55.709 32.0795 55.709 25.0004V8.33369C55.709 7.27704 56.3443 6.30286 57.3085 5.92407ZM61.8125 15.5218L60.959 14.6683V15.8754V25.0004C60.959 30.3757 61.6456 33.9566 63.845 36.156C66.0445 38.3554 69.6253 39.042 75.0007 39.042H84.1257H85.3328L84.4792 38.1885L61.8125 15.5218Z"
        fill="var(--color-stroke-active)"
        stroke="var(--color-stroke-active)"
      />
      <path
        d="M54.166 56.793H29.166C27.7338 56.793 26.541 55.6002 26.541 54.168C26.541 52.7358 27.7338 51.543 29.166 51.543H54.166C55.5982 51.543 56.791 52.7358 56.791 54.168C56.791 55.6002 55.5982 56.793 54.166 56.793Z"
        fill="var(--color-stroke-active)"
        stroke="var(--color-stroke-active)"
      />
      <path
        d="M45.8327 73.457H29.166C27.7338 73.457 26.541 72.2642 26.541 70.832C26.541 69.3998 27.7338 68.207 29.166 68.207H45.8327C47.2649 68.207 48.4577 69.3998 48.4577 70.832C48.4577 72.2642 47.2649 73.457 45.8327 73.457Z"
        fill="var(--color-stroke-active)"
        stroke="var(--color-stroke-active)"
      />
    </svg>
  );
};

export default NoDocs;
